import { ComponentListPageState } from ".";

const displayColumn = [
  { label: "Delete", value: "cpntDelFlg" },
  { label: "Component Id", value: "cpntId" },
  { label: "Component Name", value: "cpntName" },
  { label: "Description", value: "cpntDesc" },
  { label: "GPG Encryption", value: "gpgEncryptnFlg" },
  { label: "Use Assumed Roll", value: "useAssmdRoleFlg" },
  { label: "Use EDH Converter", value: "useEdhCnvtrFlg" },
  { label: "HubFlag", value: "hubFlg" },
  { label: "EDHProtocol", value: "edhPrtclDsplyNameConcat" },
  { label: "EDI Usage", value: "ediUsgFlg" },
];

export const ComponentListPageInitialState: ComponentListPageState = {
  searchResult: {
    rootCpntDelFlg: "",
    rootCpntId: "",
    rootCpntName: "",
    dipByRgn: "",
    ownTypeCd: "",
    ownTypeName: "",
    systemName: "",
    systemId: "",
    subSystemId: "",
    notSysUsg: "",
    alctnTypeCd: "",
    alctnTypeName: "",
    clodSrvcTypeCd: "",
    clodSrvcTypeName: "",
    rgnTypeCd: "",
    rgnTypeName: "",
    acntName: "",
    updateDateTimeMRootCpnt: "",
    rootCpntIchrList: [],
    cpntList: [],
  },
  dataList: {
    inDefCommonFlagType: [],
  },
  displayColumn: displayColumn,
  editDataList: {
    cpntOwnType: [],
    cpntAlctnType: [],
    clodSrvc: [],
    clodSrvcRgn: [],
  },
};
